import { render } from "./LuxComposer.vue?vue&type=template&id=130e6118&scoped=true&ts=true"
import script from "./LuxComposer.vue?vue&type=script&lang=ts"
export * from "./LuxComposer.vue?vue&type=script&lang=ts"

import "./LuxComposer.vue?vue&type=style&index=0&id=130e6118&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130e6118"]])

export default __exports__